module.exports = __webpack_public_path__ + "img/environment4.9db17230.png";